import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

/**
 * The federations and grades of ONE record — `resource` is its collection
 * (`sportsmen`, `trainers`, `secretaries`, `referees`), for a form that only
 * holds the copy embedded in a profile. Resolves `{disciplines, grades}`, or
 * null when it cannot be read (the error is shown as any other).
 */
export const fetchRecordDisciplines = (resource, id) => dispatch => {
    const params = [];
    params['resource'] = resource;
    params['id'] = id;

    return axios(apiRequestOptions(apiPath.DISCIPLINES.OF_RECORD, null, { params }))
        .then(transformHttpResponse)
        .then(response => ({
            disciplines: (response.data && response.data.disciplines) || [],
            grades: (response.data && response.data.grades) || [],
        }))
        .catch(error => transformHttpResponse(error.response))
        .catch(error => {
            dispatch(errorRequestHandler(error));

            return null;
        });
};
